module.exports = __webpack_public_path__ + "img/img18.23d11511.svg";